<img
  class="logo-image"
  [src]="imgpath"
  style="max-width: var(--width-content-max)"
  alt="Lasuite"
/>
